/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SlideshowComponentEditWrapper } from "cms/components/components/hero-slideshow/edit/component-slideshow-wrapper";
import { HeroSlideshowSlideEditor } from "cms/components/components/hero-slideshow/edit/hero-slideshow-slide-editor";
import { ErrorBoundary } from "react-error-boundary";
import { FieldErrorFallback } from "cms/fields/layout/field-error";

const HeroSlideshowComponentEditor = () => {
    
    const { component, update } = useUpdateComponent();
    const { slides } = component;
    
    const onChangeList = (slides) => {
        update("slides", slides);
    };
    
    return (
        <div className='simplicity-editor-frame'>
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    location.reload(); 
                }}
            >
                <SlideshowComponentEditWrapper
                    slides={slides}
                    onChangeList={onChangeList}
                >
                    {/* Hero Slideshow Slide */}
                    <HeroSlideshowSlideEditor />
                </SlideshowComponentEditWrapper>
            </ErrorBoundary>
        </div>
    );
};
HeroSlideshowComponentEditor.displayName = "HeroSlideshowComponentEditor";
export { HeroSlideshowComponentEditor };
